/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
window.addEventListener('resize', handleResize);
handleResize();
function handleResize() {
  const currentWidth = window.innerWidth;
  const mobileForm = document.querySelector('.mob-search');
  const desktopForm = document.querySelector('.desk-search');

  if (currentWidth < 1320) {
    // Set action to /search for mobile form
    mobileForm.removeAttribute('action'); // Remove any existing action
    mobileForm.setAttribute('action', '/search'); // Set new action

    // Set action to default (or empty) for desktop form
    desktopForm.removeAttribute('action'); // Remove any existing action
    desktopForm.setAttribute('action', '/'); // Set new action
  } else {
    // Set action to default (or empty) for mobile form
    mobileForm.removeAttribute('action'); // Remove any existing action
    mobileForm.setAttribute('action', '/'); // Set new action

    // Set action to /search for desktop form
    desktopForm.removeAttribute('action'); // Remove any existing action
    desktopForm.setAttribute('action', '/search'); // Set new action
  }
}

